import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import Dashboard from "@/pages/Dashboard";
import Ledgers from "@/pages/Ledgers";
import Parties from "@/pages/Parties";
import Items from "@/pages/Items";
import Vouchers from "@/pages/Vouchers";
import InvoiceEditor from "@/pages/InvoiceEditor";
import Inventory from "@/pages/Inventory";
import Banking from "@/pages/Banking";
import Reports from "@/pages/Reports";
import Compliance from "@/pages/Compliance";
import Copilot from "@/pages/Copilot";
import Migration from "@/pages/Migration";
import Notes from "@/pages/Notes";
import PaymentResult from "@/pages/PaymentResult";
import Settings from "@/pages/Settings";

function Guard({ children }) {
  const { user, companies, company } = useApp();
  if (user === null || (user && companies === null))
    return (
      <div className="flex h-screen items-center justify-center text-sm text-muted-foreground" data-testid="app-loading">
        Loading FinAxis…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (!company && (companies || []).length === 0) return <Navigate to="/setup" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/setup" element={<Setup />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
      <Route
        element={
          <Guard>
            <Shell />
          </Guard>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/masters/ledgers" element={<Ledgers />} />
        <Route path="/masters/parties" element={<Parties />} />
        <Route path="/masters/items" element={<Items />} />
        <Route path="/vouchers" element={<Vouchers />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/invoices/:kind/new" element={<InvoiceEditor />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/banking" element={<Banking />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/copilot" element={<Copilot />} />
        <Route path="/migration" element={<Migration />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AppProvider>
  );
}
